import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

/**
 * CC-14: the single translation layer every user-facing string goes through.
 * `en` is the only shipped locale today — this module is the plumbing, not a
 * translation effort — but routing every string through `t()` from here on
 * means adding a second locale later is "add a JSON file", not "find every
 * hardcoded string in the app".
 *
 * Imported for its side effect (by `main.tsx` for the real app, and by
 * `test/setup.ts` for every test file). `init()` returns a promise, but with
 * bundled resources and no backend/detector plugins it resolves within the
 * same microtask queue flush, before React's initial commit — proven by
 * `accessibility.test.tsx`/`shell.test.tsx` asserting on translated text with
 * synchronous `getByText`/`getByRole`, not `findBy*`.
 *
 * Guarded by `isInitialized`: `test/setup.ts` and `main.tsx` both import this
 * module, and in a test run they can both execute against the same
 * process — re-initializing would be wasted work, not a correctness issue,
 * but the guard keeps it a true no-op.
 */
if (!i18next.isInitialized) {
  void i18next.use(initReactI18next).init({
    resources: { en: { translation: en } },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false }, // React already escapes.
  });
}

export default i18next;
